import React from 'react';
import './typography.css';

export interface PageHeaderProps {
  /** Page title, rendered as the page's single h1. */
  title: React.ReactNode;
  /** Optional one-line description under the title. */
  subtitle?: React.ReactNode;
  /** Optional actions (buttons) aligned to the end of the header. */
  actions?: React.ReactNode;
}

/**
 * Standard header for every Passport admin page. Sizing comes exclusively from
 * the shared typography tokens via the `admin-page-title` / `admin-page-subtitle`
 * classes, so no page needs (or may use) inline font sizes for its title.
 */
export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions }) => {
  const headerClassName = actions
    ? 'admin-page-header admin-page-header--with-actions'
    : 'admin-page-header';

  return (
    <div className={headerClassName}>
      <div className="admin-page-header__text">
        <h1 className="admin-page-title">{title}</h1>
        {subtitle ? <p className="admin-page-subtitle">{subtitle}</p> : null}
      </div>
      {actions ? <div className="admin-page-header__actions">{actions}</div> : null}
    </div>
  );
};
